import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-thin-up",
  "use": "icon-arrow-thin-up-usage",
  "viewBox": "0 0 800 800",
  "content": "<symbol viewBox=\"0 0 800 800\" id=\"icon-arrow-thin-up\">\n  <defs>\n    <style>\n      #icon-arrow-thin-up .cls-1 {\n        fill: #010002;\n      }\n    </style>\n  </defs>\n  <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->\n  <g>\n    <g id=\"icon-arrow-thin-up_Layer_1\">\n      <g id=\"icon-arrow-thin-up_Capa_1\">\n        <polygon class=\"cls-1\" points=\"138.4 261.6 159.2 282.4 385.3 56.3 385.3 800 414.7 800 414.7 56.3 640.8 282.4 661.6 261.6 400 0 138.4 261.6\" />\n      </g>\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-thin-up.svg
// module id = etJ3
// module chunks = 175